import type { FC, SyntheticEvent } from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

import type { TMenuItem } from '@/_instructor/my-courses/use-card-logic';

import Skeleton from '../skeleton';

const StyledList = styled(List, {
  shouldForwardProp: (prop) => prop !== 'single',
})<{ single?: boolean }>(({ theme, single }) => {
  return {
    borderRadius: single ? 0 : 12,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    padding: '0',
    marginTop: single ? 12 : 4,
    overflow: 'hidden',
    '& .MuiListItem-container': {
      color: theme.palette.text.secondary,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderTop: single ? `1px solid ${theme.palette.divider}` : null,
      '& .MuiListItemText-primary': {
        fontWeight: 500,
      },
      '& .MuiListItem-button': {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 0,
        paddingRight: 32,
      },
      '&:last-of-type': {
        borderBottom: `none`,
      },
      '& .Mui-disabled': {
        opacity: 1,
      },
      '& .odt': {
        color: theme.palette.secondary.main,
      },
      '& .lesson': {
        color: theme.palette.success.main,
      },
      '&.lesson': {
        color: theme.palette.primary.main,
      },
      '& .resource': {
        color: theme.palette.primary.main,
      },
      '&:hover': {
        color: theme.palette.primary.main,
      },
      '&.disabled': {
        color: theme.palette.action.disabled,
      },
      '& .MuiButtonBase-root:hover': {
        background: theme.palette.action.disabled,
      },
      '& .MuiListItemSecondaryAction-root': {
        right: 4,
        cursor: 'pointer',
      },
    },
  };
});

// type TMenuItemProps = { visible: boolean; disabled: boolean; id: string; name: string; icon: ReactNode };

interface IProps {
  menu: TMenuItem[];
  preload: boolean;
  callback: (e: TMenuItem) => (e: SyntheticEvent) => void;
}

const CardMenu: FC<IProps> = ({ menu, preload, callback }) => {
  const visibleMenu = menu?.filter((m) => m.visible);

  return (
    <StyledList dense single={visibleMenu.length === 1}>
      {visibleMenu.map((v) => {
        if (preload) {
          return (
            <div className={preload ? 'w-full px-0 py-2' : 'w-full p-2'} key={v.id}>
              <Skeleton width="100%" height={28} variant="rectangular" />
            </div>
          );
        }

        return (
          <ListItem
            ContainerProps={{
              className: `${v.disabled ? 'disabled' : ''}${v.id === 'lesson' && !v.disabled ? v.id : ''}`,
            }}
            key={v.id}
            button
            disabled={v.disabled}
            onClick={callback(v)}
          >
            <ListItemText primary={<span>{v.name}</span>} />
            <ListItemSecondaryAction className="text-lg">{v.icon}</ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </StyledList>
  );
};

export default CardMenu;
